import { render, staticRenderFns } from "./NewsletterFooter.vue?vue&type=template&id=4552623c"
import script from "./NewsletterFooter.vue?vue&type=script&lang=js"
export * from "./NewsletterFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports